<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        color="grey lighten--3"
        :class="['cursor-pointer', className]"
        small
        fab
        v-bind="attrs"
        v-on="on"
        >mdi-information-outline</v-icon
      >
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    text: { type: String, default: "" },
    className: { type: String, default: "" },
  },
};
</script>

<style>
</style>